// export const LOGOUT_OK = state => {
//   state.user = {}
//   state.roles = null
//   state.loggedIn = false
// }

export const getMockGps = (state, res) => {
  state.mockGps = res
}

export const getFailedJobs = (state, res) => {
  state.failedJobs = res
}

export const getJobs = (state, res) => {
  state.jobs = res
}
